export var Name = 'show-error-notification';
export var ShowErrorNotificationEvent = Name;
export var defaultMessageTranslations = {
  genericError: 'Sorry, something went wrong!',
  selectedQuantityIsNotAvailable: 'Selected quantity is not available due to stock limitations.',
  offerIsNotAvailable: 'Offer is not available at the moment.'
};
export var translationKeys = Object.fromEntries(Object.keys(defaultMessageTranslations).map(function (cur) {
  return [cur, cur];
}));